import React, { Component } from "react"
import WidgetSection from "./footer-widget-section"
import "./footer.css"
import FooterCopyright from "./footer-copyright-section"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <WidgetSection />
        <FooterCopyright />
      </React.Fragment>
    )
  }
}

export default Footer
